import { OrganizationBillingCategoryCode } from "@api/shared-runtime/enums";

export type UsageBillingColumn = {
  categoryCode: OrganizationBillingCategoryCode;
  columnLabel: string;
};

// Fixed column order for the summary table. A category code that isn't
// listed here has no dedicated column and only shows up inside a unit's
// expanded event list.
const FIXED_COLUMNS = ["Business unit", "Provider wages", "Cycle totals"];

export const USAGE_BILLING_COLUMNS: UsageBillingColumn[] = [
  {
    categoryCode: OrganizationBillingCategoryCode.ProviderReveal,
    columnLabel: "Reveals",
  },
  {
    categoryCode: OrganizationBillingCategoryCode.JobPost,
    columnLabel: "Posts",
  },
  {
    categoryCode: OrganizationBillingCategoryCode.DocumentSignature,
    columnLabel: "Docs",
  },
  {
    categoryCode: OrganizationBillingCategoryCode.ProviderMonitoring,
    columnLabel: "Monitoring",
  },
  {
    categoryCode: OrganizationBillingCategoryCode.ShiftMarkup,
    columnLabel: "Shift markup",
  },
];

export const USAGE_BILLING_COLUMN_COUNT =
  FIXED_COLUMNS.length + USAGE_BILLING_COLUMNS.length;
